import {normalizeTrack} from './listeningHistory';

export const findSkippedSongs = (selectedPlaylist, threshold, jsonData, setSkippedSongs) => {
    if (!selectedPlaylist) {
        alert("Please select a playlist to filter by.");
        return;
    }

    const playlistSet = new Set(
        selectedPlaylist.tracks.map(track =>
            `${track.artist} - ${track.name}`.toLowerCase()
        )
    );

    const normalizedTracks = jsonData.map(normalizeTrack);

    const relevantTracks = normalizedTracks.filter(track =>
        playlistSet.has(`${track.artistName} - ${track.trackName}`.toLowerCase())
    );

    const skipped = relevantTracks.filter(track => track.msPlayed < threshold);
    const played = relevantTracks.filter(track => track.msPlayed >= threshold);

    const groupTracks = (tracks) => {
        const grouped = {};

        tracks.forEach((track) => {
            const key = `${track.artistName} - ${track.trackName}`;

            const playlistTrack = selectedPlaylist.tracks.find(playlistTrack =>
                `${playlistTrack.artist} - ${playlistTrack.name}`.toLowerCase() === key.toLowerCase()
            );

            const trackUri = playlistTrack?.uri || null;
            const trackId = playlistTrack?.id || null;

            if (!grouped[key]) {
                grouped[key] = {
                    artistName: track.artistName,
                    trackName: track.trackName,
                    skipCount: 0,
                    playCount: 0,
                    totalSkippedMs: 0,
                    totalPlayedMs: 0,
                    uri: trackUri,
                    id: trackId,
                };
            }

            if (track.msPlayed < threshold) {
                grouped[key].skipCount += 1;
                grouped[key].totalSkippedMs += track.msPlayed;
            } else {
                grouped[key].playCount += 1;
                grouped[key].totalPlayedMs += track.msPlayed;
            }
        });

        return grouped;
    };

    const groupedData = groupTracks([...skipped, ...played]);

    const merged = Object.values(groupedData)
        .map((track) => {
            const totalPlays = track.skipCount + track.playCount;
            const ratio = track.skipCount / (track.playCount || 1);
            return {
                ...track,
                totalPlays,
                ratio,
                displayName: `${track.artistName} - ${track.trackName}`,
            };
        })
        .sort((a, b) => b.skipCount - a.skipCount);

    setSkippedSongs(merged);
};
